module.exports = __webpack_public_path__ + "img/welcome-mockup.dc0f5d62.png";